// sending buffer through server as JSON will remove it's type, those functions help to fix that
export const bufferToHex = (buffer: ArrayLike<number>) =>
    Array.from(buffer, (x: number) => x.toString().padStart(2, '0')).join('');

// buffer to array
export const deBuffer = (buffer: ArrayBuffer) => Array.from(new Uint8Array(buffer));

// array to buffer
export const reBuffer = (array: number[]) => new Uint8Array(array);
